export default __webpack_public_path__ + "static/media/4_banner_verticalname_small_bronto.b9f5011b.png";